import { Link } from '@tanstack/react-router';
import { Badge } from '@upme/ui/components/badge';
import { Button } from '@upme/ui/components/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@upme/ui/components/table';
import type { PaymentProviderDto } from '../schema';

export function ProvidersTable({
  providers,
  onDelete,
}: {
  providers: PaymentProviderDto[];
  onDelete: (id: string) => void;
}) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Название</TableHead>
          <TableHead>Тип</TableHead>
          <TableHead>Режим</TableHead>
          <TableHead>Статус</TableHead>
          <TableHead className="text-right">Действия</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {providers.map((p) => (
          <TableRow key={p.id}>
            <TableCell>{p.name}</TableCell>
            <TableCell>{p.type}</TableCell>
            <TableCell>{p.mode}</TableCell>
            <TableCell>
              <div className="flex flex-wrap gap-1">
                {p.isActive ? (
                  <Badge variant="default">активен</Badge>
                ) : (
                  <Badge variant="secondary">выключен</Badge>
                )}
                {p.credentialsError ? (
                  <Badge
                    variant="destructive"
                    title="Не удалось расшифровать креды — проверьте PAYMENTS_ENC_KEY"
                  >
                    ключ не подходит
                  </Badge>
                ) : null}
              </div>
            </TableCell>
            <TableCell className="text-right">
              <div className="flex justify-end gap-2">
                <Button asChild variant="outline" size="sm">
                  <Link to="/payment-providers/$providerId" params={{ providerId: p.id }}>
                    Изменить
                  </Link>
                </Button>
                <Button variant="destructive" size="sm" onClick={() => onDelete(p.id)}>
                  Удалить
                </Button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
